import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "highlight bm20" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "social-media" }
const _hoisted_9 = { class: "right-side" }
const _hoisted_10 = { class: "text" }

import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import RocketIcon from "@/components/icons/RocketIcon.vue";
import StarsIcon from "@/components/icons/StarsIcon.vue";
import AboutMeIcon from "@/components/icons/AboutMeIcon.vue";
import PortfolioIcon from "@/components/icons/PortfolioIcon.vue";
import ArticlesIcon from "@/components/icons/ArticlesIcon.vue";
import YoutubeIcon from "@/components/icons/YoutubeIcon.vue";
import KaggleIcon from "@/components/icons/KaggleIcon.vue";
import TelegramIcon from "@/components/icons/TelegramIcon.vue";
import GithubIcon from "@/components/icons/GithubIcon.vue";
import ResumeIcon from "@/components/icons/ResumeIcon.vue";

import DiamondLine from "@/components/DiamondLine.vue";
import NavBtn from "@/components/NavBtn.vue";
import SocialMediaBtn from "@/components/SocialMediaBtn.vue";
import PhotoSlider from '@/components/PhotoSlider.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t, locale } = useI18n();
const route = useRoute();
const currentLang = computed(() => (route.params.lang as string) || (locale as any)?.value || 'en')
const getLang = () => (route.params.lang as string) || (locale as any)?.value || 'en'

const photos = [
  require('@/assets/my-photo.jpg'),
  require('@/assets/my-photo1.png'),
  require('@/assets/my-photo3.jpg'),
  require('@/assets/my-photo2.jpg'),
  require('@/assets/my-photo4.jpg'),
  require('@/assets/my-photo5.jpg'),
  require('@/assets/my-photo6.jpg')
];

const altTexts = computed(() => {
  if (locale.value === 'ru') {
    return [
      'Фото Дмитрия (DIMFLIX) — портрет',
      'Фото Дмитрия (DIMFLIX) — Full‑Stack & AI/ML разработчик',
      'Фото Дмитрия (DIMFLIX) — за работой',
      'Фото Дмитрия (DIMFLIX) — профильный снимок',
      'Фото Дмитрия (DIMFLIX) — рабочий момент',
      'Фото Дмитрия (DIMFLIX) — неформальный портрет'
    ]
  }
  return [
    'Photo of Dmitry (DIMFLIX) — portrait',
    'Photo of Dmitry (DIMFLIX) — Full‑Stack & AI/ML developer',
    'Photo of Dmitry (DIMFLIX) — at work',
    'Photo of Dmitry (DIMFLIX) — profile shot',
    'Photo of Dmitry (DIMFLIX) — work moment',
    'Photo of Dmitry (DIMFLIX) — candid portrait'
  ]
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RocketIcon, { class: "icon" }),
        _createElementVNode("h1", {
          class: "text",
          innerHTML: _ctx.$t('home.title')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("p", {
        class: "description",
        innerHTML: _ctx.$t('home.description')
      }, null, 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(StarsIcon, { class: "icon" }),
        _createElementVNode("p", {
          class: "text",
          innerHTML: _ctx.$t('home.highlighted_text')
        }, null, 8, _hoisted_7)
      ]),
      _createVNode(DiamondLine, { class: "bm30" }),
      _createVNode(NavBtn, {
        title: _unref(t)('home.nav.about_me.title'),
        IconComponent: AboutMeIcon,
        description: _unref(t)('home.nav.about_me.description'),
        url: { name: 'about', params: { lang: getLang() } },
        class: "bm20"
      }, null, 8, ["title", "description", "url"]),
      _createVNode(NavBtn, {
        title: _unref(t)('home.nav.portfolio.title'),
        IconComponent: PortfolioIcon,
        description: _unref(t)('home.nav.portfolio.description'),
        url: { name: 'portfolio', params: { lang: getLang() } },
        class: "bm20"
      }, null, 8, ["title", "description", "url"]),
      _createVNode(NavBtn, {
        title: _unref(t)('home.nav.articles.title'),
        IconComponent: ArticlesIcon,
        description: _unref(t)('home.nav.articles.description'),
        url: { name: 'Articles', params: { lang: getLang() } },
        class: "bm30"
      }, null, 8, ["title", "description", "url"]),
      _createVNode(DiamondLine, { class: "bm30" }),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(SocialMediaBtn, {
          IconComponent: YoutubeIcon,
          url: "https://www.youtube.com/dimflix",
          color: "var(--maroon-color)"
        }),
        _createVNode(SocialMediaBtn, {
          IconComponent: KaggleIcon,
          url: "https://www.kaggle.com/dimflix",
          color: "var(--sky-color)"
        }),
        _createVNode(SocialMediaBtn, {
          IconComponent: TelegramIcon,
          url: "https://t.me/dimflix_official",
          color: "var(--lavender-color)"
        }),
        _createVNode(SocialMediaBtn, {
          IconComponent: GithubIcon,
          url: "https://github.com/DIMFLIX",
          color: "var(--button-color)"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(PhotoSlider, {
        photos: photos,
        interval: 3000,
        "show-frame": true,
        "show-indicators": true,
        "alt-texts": altTexts.value
      }, null, 8, ["alt-texts"]),
      _createVNode(_component_router_link, {
        to: { name: 'resume', params: { lang: getLang() } },
        class: "resume-btn"
      }, {
        default: _withCtx(() => [
          _createVNode(ResumeIcon),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('home.resume_btn')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})